import { render, staticRenderFns } from "./OperaAreaUserWindow.vue?vue&type=template&id=37ef3870&scoped=true&"
import script from "./OperaAreaUserWindow.vue?vue&type=script&lang=js&"
export * from "./OperaAreaUserWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaAreaUserWindow.vue?vue&type=style&index=0&id=37ef3870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef3870",
  null
  
)

export default component.exports